// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__2d2A-","Div":"CustomFadeBox_Div__KSTai","LargeDiv":"CustomFadeBox_LargeDiv__3vkFL"};